export default {
    async listaChamados({commit, getters})
	{
        let usuario = JSON.parse(sessionStorage.getItem("user"))
        //let token = rootState.system.token


        let {data} = await getters.getService.get(`pxtalk/allhistorico/${usuario.empresa_id}`)
        commit('SET_CHAMADOS', data.chamados)
        //console.log('opa', data)
        return await data

    },

    async listaConversas({commit, getters, rootState}, protocolo)
    {
        //buscar no banco as mensagens da conversa
        await commit('SET_CONVERSA', protocolo)

        return await protocolo

    },

    /*async listaGrupos({commit,getters,rootState})
    {
        let usuario = JSON.parse(sessionStorage.getItem("user"))
        let token = rootState.system.token

        let {data} = await rootState.system.$barramento.get(`loginServer/grupos/${usuario.empresa_id}/${rootState.pxtalk.app_id}`, token)

        await commit('SET_GRUPOS', data)
        return await data
    },*/

    async listaTaxistas({commit,getters,rootState}, id)
    {
        //let id = rootState.pxtalk.grupo_taxistas
        //let token = rootState.system.token

        //console.log(id)

        let {data} = await getters.getService.get(`loginServer/users/grupos/${id}`)

        await commit('SET_TAXISTAS', data)
        return await data
    },

    async cadastraTaxistas({commit,getters,rootState}, taxista)
    {
        //let token = rootState.system.token

        let {data} = await getters.getService.post(`loginServer/usuarios`, taxista)
        return await data
    },

    async alteraTaxista({dispatch, commit, getters, rootState}, taxista)
    {
        //let token = rootState.system.token

        let {data} = await getters.getService.put(`loginServer/usuarios`, taxista)

        //dispatch('listaTaxistas', taxista._id)

        return await data
    },

    async deletaTaxista({commit, getters, rootState}, taxista_id)
    {
        //let token = rootState.system.token

        let {data} = await getters.getService.delete(`loginServer/usuarios/${taxista_id}`)

        return await data
    },

    /*async listaGrupoAgentes({commit,getters,rootState})
    {
        let usuario = JSON.parse(sessionStorage.getItem("user"))
        let token = rootState.system.token

        let {data} = await rootState.system.$barramento.get(`loginServer/grupos/${usuario.empresa_id}/${rootState.pxtalk.dash_id}`, token)

        await commit('SET_GRUPOS', data)
        return await data
    },*/

    async listaAgentes({commit,getters,rootState}, id)
    {
        //let id = rootState.pxtalk.grupo_agentes
        //let token = rootState.system.token

        //console.log(id)

        let {data} = await getters.getService.get(`loginServer/users/grupos/${id}`)

        await commit('SET_AGENTES', data)
        return await data
    },

    async cadastraAgente({commit,getters,rootState}, agente)
    {
        //let token = rootState.system.token

        let {data} = await getters.getService.post(`loginServer/usuarios`, agente)
        return await data
    },

    async alteraAgente({commit,getters,rootState}, agente)
    {
        //let token = rootState.system.token

        let {data} = await getters.getService.put(`loginServer/usuarios`, agente)
        return await data
    },

    async deletaAgente({commit, getters, rootState}, agente_id)
    {
        let token = rootState.system.token

        let {data} = await getters.getService.delete(`loginServer/usuarios/${agente_id}`)

        return await data
    },

    async getGroupsManager({dispatch,commit,getters, rootState})
    {
        let usuario = JSON.parse(sessionStorage.getItem("user"))

        //let token = rootState.system.token

        let { data } = await getters.getService.get(`loginServer/grupos/${usuario.empresa_id}/${getters.getAppId}`)
        await commit('SET_GROUPSMANAGER', data)
            if(rootState.pxtalk.grupo_agentes && rootState.pxtalk.grupo_taxistas)
            {
                dispatch('listaAgentes', rootState.pxtalk.grupo_agentes)

                dispatch('listaTaxistas', rootState.pxtalk.grupo_taxistas)
            }

        return await data
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/pxtalk/actions.js